export default __webpack_public_path__ + "static/media/watermark-cover-art.ad940f09.png";